<div class="layout-topbar no-print hidden-print">
    <a class="logo" (click)="RouterNavigation('/' + base_url + '/dashboard')" style="cursor: pointer;">
        <img [src]="provider_img" style="height:50px;" alt="egd-logo" />
    </a>
    <a id="menu-button" href="#" (click)="app.onMenuButtonClick($event)">
        <i class="fa fa-align-justify"></i>
    </a>
    <a id="topbar-menu-button" *ngIf="app.profileMode === 'top' || app.isHorizontal()">
        <p-tabMenu [model]="items"></p-tabMenu>
    </a>

    <ul id="topbar-usermenu" class="usermenu usermenu-overlay fadeInDown"
        [ngClass]="{'usermenu-active': app.topbarMenuActive}" *ngIf="is_primary_provider">
        <li #profile [ngClass]="{'menuitem-active': app.activeTopbarItem === profile}">
            <a [routerLink]="['/', slug, base_url, edit_url]" (click)="app.onTopbarItemClick($event, profile)">
                <i class="fa fa-fw fa-user"></i>
                <span class="topbar-item-name">Edit Profile</span>
            </a>
        </li>
    </ul>

    <a id="right-sidebar-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
        <i class="fa fa-gear"></i>
    </a>
</div>
